import { render } from "./OpenAiIntegrationFormPage.vue?vue&type=template&id=8b8348b6&ts=true"
import script from "./OpenAiIntegrationFormPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenAiIntegrationFormPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/integration/OpenAiIntegrationFormPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b8348b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b8348b6', __exports__)) {
    api.reload('8b8348b6', __exports__)
  }
  
  module.hot.accept("./OpenAiIntegrationFormPage.vue?vue&type=template&id=8b8348b6&ts=true", () => {
    api.rerender('8b8348b6', render)
  })

}


export default __exports__